export const FETCH_HOTEL_DETAILS = 'FETCH_HOTEL_DETAILS'
export const FETCH_HOTELS_FOR_LAT_LNG = 'FETCH_HOTELS_FOR_LAT_LNG'
